import { UserApi } from 'mvppoker-portal-common/api'
import React, { useState } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { ActiveUser, updateWallet } from '../../../state/reducers/activeUser'
import { useApi } from '../../../utils/useApi'
import { createMVPModal } from '../Modal'
import { WalletAddressModalView } from './WalletAddressModalView'
import { useActiveUser } from '../../../state/hooks/ActiveUserHooks'

class WalletAddressModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('wallet-address-modal', () =>
		{
			const modal = useModal()
			const activeUser = useActiveUser()
			const currentAddress =  activeUser?.wallet?.address
			const [isLoading, setLoading] = useState(false)
			const api = useApi(UserApi)
			const dispatch = useDispatch()
		
			const clickCancel = () => { modal.hide() }

			const clickSubmit = (address: string) => {
				setLoading(true)
		
				api.usersWalletUpdateAddress({ value: address })
					.then((wallet) => dispatch(updateWallet(wallet.data)))
					.then(() => {
						toast.success('Wallet address updated!')
						modal.resolve()
						modal.hide()
					})
					.catch((err) => {
						toast.error('An error occurred')
						modal.reject(err)
						setLoading(false)
					})
			}

			return <div> </div>
			// return <WalletAddressModalView 
			// 	currentAddress={currentAddress}
			// 	isLoading={isLoading}
			// 	clickCancel={clickCancel}
			// 	clickSubmit={clickSubmit}
			// />
		}))
	}
}

const modal = new WalletAddressModal()
export default modal